import {
  AppBar,
  Container,
  Dialog,
  Grid,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Historial } from "../../../interfaces/historial-bl/historial.bl.interface";
import { IconX } from "@tabler/icons-react";
import React, { useEffect, useState, useCallback } from "react";
import { TransitionProps } from "@material-ui/core/transitions";
import { format } from "date-fns";
import {
  keysToDisplayBL,
  keysToDisplayContainers,
} from "../constants/keys.constants";

interface props {
  historial: Historial | undefined;
  onClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

interface ObjectToCompare {
  key: string;
  name_prop: string;
  isChanged: boolean;
  newValue: string;
  oldValue: string;
}

const DialogHistorialBl = ({ historial, onClose }: props) => {
  const [arrayDiferences, setArrayDiferences] = useState<ObjectToCompare[]>([]);
  const [arrayDiferencesContainers, setArrayDiferencesContainers] = useState<
    [ObjectToCompare[]?]
  >([]);

  const arrayDiferencesBuilder = useCallback(
    (obj1: any, obj2: any, keysToDisplay: any) => {
      const arrayDiferencesTemp: ObjectToCompare[] = [];

      for (const attr in obj1) {
        if (obj2.hasOwnProperty(attr) && obj2.hasOwnProperty(attr)) {
          arrayDiferencesTemp.push({
            isChanged: obj1[attr] !== obj2[attr] ? true : false,
            key: attr,
            name_prop:
              keysToDisplay.find((element: any) => element.key === attr)
                ?.label || "",
            newValue: obj2[attr],
            oldValue: obj1[attr],
          });
        }
      }

      return arrayDiferencesTemp;
    },
    []
  );

  useEffect(() => {
    try {
      const newArrayDiferencesBL = arrayDiferencesBuilder(
        historial?.bl_json_original,
        historial?.bl_json_modificado,
        keysToDisplayBL
      );
      setArrayDiferences(newArrayDiferencesBL);

      // Setting array containers
      const arrayLength = historial?.contenedores_original?.length || 0;
      const arrayParentDiferencesContainers: [ObjectToCompare[]?] = [];
      for (let i = 0; i < arrayLength; i++) {
        const obj1 =
          historial?.contenedores_original !== undefined
            ? historial?.contenedores_original[i]
            : {};
        const obj2 =
          historial?.contenedores_modificado !== undefined
            ? historial?.contenedores_modificado[i]
            : {};
        const newArrayDiferencesContainers = arrayDiferencesBuilder(
          obj1,
          obj2,
          keysToDisplayContainers
        );
        arrayParentDiferencesContainers.push(newArrayDiferencesContainers);
      }
      setArrayDiferencesContainers(arrayParentDiferencesContainers);
    } catch (error) {
      console.log(error);
    }
  }, [historial, arrayDiferencesBuilder]);

  return (
    <>
      <Dialog
        fullScreen
        open={Boolean(historial !== undefined)}
        TransitionComponent={Transition}
      >
        <AppBar
          elevation={0}
          color="transparent"
          style={{
            position: "sticky",
            top: 0,
            marginBottom: 10,
            borderBottom: "1px solid gainsboro",
            backgroundColor: "white",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <IconX />
            </IconButton>
            <Typography variant="h6">Detalles</Typography>
          </Toolbar>
        </AppBar>
        <Container maxWidth="xl">
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Typography variant="h5" align="center">
                BL Original
              </Typography>
              <Typography align="center">
                {historial?.bl_json_original.fecha_ingreso.length > 0
                  ? format(
                      new Date(historial?.bl_json_original.fecha_ingreso!),
                      "dd/MM/yyy - HH:mm"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h5" align="center">
                BL Modificado
              </Typography>
              <Typography align="center">
                {historial !== undefined &&
                historial?.fecha_modificacion.length > 0
                  ? format(
                      new Date(historial?.fecha_modificacion!),
                      "dd/MM/yyy - HH:mm"
                    )
                  : ""}
              </Typography>
            </Grid>
            <br />
            <table
              width="100%"
              style={{
                border: "1px solid gainsboro",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                {arrayDiferences
                  .filter((element) =>
                    keysToDisplayBL
                      .map((element) => element.key)
                      .includes(element.key)
                  )
                  .map((element, index) => (
                    <tr
                      key={index}
                      style={{
                        border: "1px solid gainsboro",
                      }}
                    >
                      {generateBLRow(element, "oldValue", `a${index}`)}
                      {generateBLRow(element, "newValue", `b${index}`)}
                    </tr>
                  ))}
                <tr style={{ border: 0 }}>
                  <td>
                    <Typography variant="h6" align="center">
                      Contenedores
                    </Typography>
                  </td>
                  <td style={{ borderLeft: "1px solid gainsboro" }}>
                    <Typography variant="h6" align="center">
                      Contenedores
                    </Typography>
                  </td>
                </tr>
                {arrayDiferencesContainers.map((_array, index) => (
                  <tr
                    key={index}
                    style={{
                      border: 0,
                    }}
                  >
                    <td
                      style={{
                        padding: "30px",
                      }}
                    >
                      <div>
                        {_array
                          ?.filter((el) =>
                            keysToDisplayContainers
                              .map((element) => element.key)
                              .includes(el.key)
                          )
                          .map((row, index) =>
                            generateContainerTable(row, `a${index}`, "oldValue")
                          )}
                      </div>
                    </td>
                    <td
                      style={{
                        padding: "30px",
                        borderLeft: "1px solid gainsboro",
                      }}
                    >
                      <div>
                        {_array
                          ?.filter((el) =>
                            keysToDisplayContainers
                              .map((element) => element.key)
                              .includes(el.key)
                          )
                          ?.map((row, index) =>
                            generateContainerTable(row, `b${index}`, "newValue")
                          )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
        </Container>
      </Dialog>
    </>
  );
};

export default DialogHistorialBl;

/**
 * Generates rows of bl
 * @param row
 * @param keyToDisplay
 * @param key
 * @returns
 */
const generateBLRow = (
  row: ObjectToCompare,
  keyToDisplay: "oldValue" | "newValue",
  key: string
) => {
  return (
    <td
      key={key}
      style={{
        width: "50%",
        border: "1px solid gainsboro",
      }}
    >
      <div
        style={{
          padding: "0px 10px",
        }}
      >
        <strong>
          <label htmlFor="">{row.name_prop}</label>
        </strong>
        <div
          style={{
            padding: row.isChanged === true ? "0px 5px" : "",
            width: "fit-content",
            borderRadius: "4px",
            backgroundColor: row.isChanged === true ? "whitesmoke" : "",
            border:
              row.isChanged === true
                ? `2px solid ${keyToDisplay === "oldValue" ? "red" : "green"}`
                : "",
          }}
        >
          {row[keyToDisplay]}
        </div>
      </div>
    </td>
  );
};

/**
 * Generates table containers
 * @param row
 * @param key
 * @param keyToDisplay
 * @returns
 */
const generateContainerTable = (
  row: ObjectToCompare,
  key: string,
  keyToDisplay: "oldValue" | "newValue"
) => {
  return (
    <table
      key={key}
      width={"100%"}
      border={1}
      style={{ borderCollapse: "collapse" }}
    >
      <tbody>
        <tr
          style={{
            border: "1px solid gainsboro",
          }}
        >
          <td style={{ padding: "0px 10px" }}>
            <strong>
              <label htmlFor="">{row.name_prop}</label>
            </strong>
            <div
              style={{
                width: "fit-content",
                padding: row.isChanged === true ? "0px 5px" : "",
                borderRadius: "4px",
                backgroundColor: row.isChanged === true ? "whitesmoke" : "",
                border:
                  row.isChanged === true
                    ? `2px solid ${
                        keyToDisplay === "oldValue" ? "red" : "green"
                      }`
                    : "",
              }}
            >
              {row[keyToDisplay]}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
